// @enum_frontend
export function inscriptionStatusStyle(){
  const defatultStyle = {
    'font-size': '14px',
  }
  return {
    "pendingApproval": {
      ...defatultStyle,
      'color': '#FF9300',
    },

    "onWaitingList": {
      ...defatultStyle,
    },

    "onTryout": {
      ...defatultStyle,
      'color': '#269DE2',
    },

    "approved": {
      ...defatultStyle,
      'color': '#2ACC73',
    },

    "pendingPayment": {
      ...defatultStyle,
      'color': '#FFCD07',
    },

    "paid": {
      ...defatultStyle,
      'color': '#2ACCCC',
    },

    "reject": {
      ...defatultStyle,
      'color': '#ee7266',
    },
  }
}

export default  inscriptionStatusStyle;